import { LatLngLiteral, divIcon } from "leaflet";
import React, { ReactElement, useEffect, useRef } from "react";
import { Marker, Popup, useMap } from "react-leaflet";
import { renderToString } from "react-dom/server";
import { MapPin } from "tabler-icons-react";

export const createLeafletIcon = (icon: ReactElement, size: number, className?: string, width: number = size, height: number = size) => {
  return divIcon({
    html: renderToString(icon),
    iconSize: [width, height],
    iconAnchor: [width / 2, height],
    popupAnchor: [0, -height],
    className: className ? className : "",
  });
};

export interface LeafletMarkerProps {
  position: LatLngLiteral;
  flyToPosition?: boolean;
  size?: number;
  color?: string;
  icon?: ReactElement;
  defaultOpen?: boolean;
  onOpen?: () => void;
  children?: React.ReactNode;
  markerType?: string;
  zIndexOffset?: number;
}

const LeafletMarker: React.FC<LeafletMarkerProps> = ({
  position,
  flyToPosition = false,
  children,
  size = 30,
  color,
  defaultOpen = true,
  onOpen,
  icon = <MapPin size={size} color={color} />,
  markerType,
  zIndexOffset,
}) => {
  const map = useMap();

  const markerRef = useRef(null);
  position && flyToPosition && map.flyTo(position);

  const markerIcon = createLeafletIcon(icon, size, markerType); // Important to not get default styling
  useEffect(() => {
    if (defaultOpen) {
      try {
        // @ts-ignore
        if (markerRef.current !== null && !markerRef.current.isPopupOpen()) {
          // @ts-ignore
          markerRef.current.openPopup();
        }
      } catch (error) {}
    }
  }, [defaultOpen, position.lat, position.lng]);

  return (
    <Marker
      eventHandlers={{
        popupopen: () => onOpen && onOpen(),
      }}
      ref={markerRef}
      icon={markerIcon}
      position={position}
      zIndexOffset={zIndexOffset}
    >
      {/* autoPan important to not have jittering */}
      <Popup closeButton={false} autoPan={false} autoClose={false} closeOnClick={false} closeOnEscapeKey={false}>
        {children}
      </Popup>
    </Marker>
  );
};

export default LeafletMarker;
